
export const DELETE_WORKSHOP2 = "DELETE_WORKSHOP2"
export const DELETE_WORKSHOP2_SUCCESS = "DELETE_WORKSHOP2_SUCCESS"

export const DELETE_PRODUCT = "DELETE_PRODUCT"
export const DELETE_PRODUCT_SUCCESS = "DELETE_PRODUCT_SUCCESS"

export const DELETE_RECIPES_CATEGORY = "DELETE_RECIPES_CATEGORY"
export const DELETE_RECIPES_CATEGORY_SUCCESS = "DELETE_RECIPES_CATEGORY_SUCCESS"


export const DELETE_PRODUCTCATEGORY = "DELETE_PRODUCTCATEGORY"
export const DELETE_PRODUCTCATEGORY_SUCCESS = "DELETE_PRODUCTCATEGORY_SUCCESS"


export const GET_PRODUCTS = "GET_PRODUCTS"
export const GET_PRODUCTS_SUCCESS = "GET_PRODUCTS_SUCCESS"

export const UPDATE_PRODUCTS = "UPDATE_PRODUCTS"
export const UPDATE_PRODUCTS_SUCCESS = "UPDATE_PRODUCTS_SUCCESS"

export const ADD_PRODUCTS = "ADD_PRODUCTS"
export const ADD_PRODUCTS_SUCCESS = "ADD_PRODUCTS_SUCCESS"

export const GET_RECIPES = "GET_RECIPES"
export const GET_RECIPES_SUCCESS = "GET_RECIPES_SUCCESS"

export const ADD_RECIPES_SUCCESS = "ADD_RECIPES_SUCCESS"
export const ADD_RECIPES = "ADD_RECIPES"
export const DELETE_CERTIFICA = "DELETE_CERTIFICA"
export const DELETE_CERTIFICA_SUCCESS = "DELETE_CERTIFICA_SUCCESS"

export const UPDATE_CERTIFICA = "UPDATE_CERTIFICA"
export const UPDATE_CERTIFICA_SUCCESS = "UPDATE_CERTIFICA_SUCCESS"

export const DELETE_RECIPES = "DELETE_RECIPES"
export const DELETE_RECIPES_SUCCESS = "DELETE_RECIPES_SUCCESS"

export const UPDATE_RECIPESCATEGORY = "UPDATE_RECIPESCATEGORY"
export const UPDATE_RECIPESCATEGORY_SUCCESS = "UPDATE_RECIPESCATEGORY_SUCCESS"

export const ADD_RECIPESCATEGORY = "ADD_RECIPESCATEGORY"
export const ADD_RECIPESCATEGORY_SUCCESS = "ADD_RECIPESCATEGORY_SUCCESS"

export const GET_RECIPESCATEGORY = "GET_RECIPESCATEGORY"
export const GET_RECIPESCATEGORY_SUCCESS = "GET_RECIPESCATEGORY_SUCCESS"

export const UPDATE_PRODUCT_CATEGORY = "UPDATE_PRODUCT_CATEGORY"
export const UPDATE_PRODUCT_CATEGORY_SUCCESS = "UPDATE_PRODUCT_CATEGORY_SUCCESS"

export const ADD_PRODUCTCATEGORY = "ADD_PRODUCTCATEGORY"
export const ADD_PRODUCTCATEGORY_SUCCESS = "ADD_PRODUCTCATEGORY_SUCCESS"

export const GET_PRODUCT_CATEGORY = "GET_PRODUCT_CATEGORY"
export const GET_PRODUCT_CATEGORY_SUCCESS = "GET_PRODUCT_CATEGORY_SUCCESS"

export const DELETE_PROJECTS = "DELETE_PROJECTS"
export const DELETE_PROJECTS_SUCCESS = "DELETE_PROJECTS_SUCCESS"

export const DELETE_MAINSLIDER = "DELETE_MAINSLIDER"
export const DELETE_MAINSLIDER_SUCCESS = "DELETE_MAINSLIDER_SUCCESS"

export const ADD_MAINSLIDER = "ADD_MAINSLIDER"
export const ADD_MAINSLIDER_SUCCESS = "ADD_MAINSLIDER_SUCCESS"

export const UPDATE_MAINSLIDER = "UPDATE_MAINSLIDER"
export const UPDATE_MAINSLIDER_SUCCESS = "UPDATE_MAINSLIDER_SUCCESS"

export const UPDATE_RECIPES = "UPDATE_RECIPES"
export const UPDATE_RECIPES_SUCCESS = "UPDATE_RECIPES_SUCCESS"

export const UPDATE_REVIEW = "UPDATE_REVIEW"
export const UPDATE_REVIEW_SUCCESS = "UPDATE_REVIEW_SUCCESS"

export const ADD_CERTIFICA_SUCCESS = "ADD_CERTIFICA_SUCCESS"
export const ADD_CERTIFICA = "ADD_CERTIFICA"

export const GET_CERTIFICA_SUCCESS = "GET_CERTIFICA_SUCCESS"

export const GET_CERTIFICA = "GET_CERTIFICA"

export const GET_MAINPAGESLIDER = "GET_MAINPAGESLIDER"

export const GET_MAINPAGESLIDER_SUCCESS = "GET_MAINPAGESLIDER_SUCCESS"
export const GET_RECIPES_REVIEW_SUCCESS = "GET_RECIPES_REVIEW_SUCCESS"

export const GET_RECIPES_REVIEW = "GET_RECIPES_REVIEW"

export const DELETE_DYNAMICFORMEXTRAEXTRA_SUCCESS = "DELETE_DYNAMICFORMEXTRAEXTRA_SUCCESS"
export const DELETE_DYNAMICFORMEXTRAEXTRA = "DELETE_DYNAMICFORMEXTRAEXTRA"

export const DELETE_DYNAMICFORM = "DELETE_DYNAMICFORM"
export const DELETE_DYNAMICFORM_SUCCESS = "DELETE_DYNAMICFORM_SUCCESS"

export const DELETE_DYNAMICFORMEXTRA = "DELETE_DYNAMICFORMEXTRA"
export const DELETE_DYNAMICFORMEXTRA_SUCCESS = "DELETE_DYNAMICFORMEXTRA_SUCCESS"

export const DELETE_COURSESCHEDULES = "DELETE_COURSESCHEDULES"
export const DELETE_COURSESCHEDULES_SUCCESS = "DELETE_COURSESCHEDULES_SUCCESS"

export const ADD_GALLERYMULTIPLE = "ADD_GALLERYMULTIPLE"
export const ADD_GALLERYMULTIPLE_SUCCESS = "ADD_GALLERYMULTIPLE_SUCCESS"

export const DELETE_GALLERY = "DELETE_GALLERY"
export const DELETE_GALLERY_SUCCESS = "DELETE_GALLERY_SUCCESS"

export const ADD_GALLERY = "ADD_GALLERY"
export const ADD_GALLERY_SUCCESS = "ADD_GALLERY_SUCCESS"

export const DELETE_REFERANCES = "DELETE_REFERANCES"
export const DELETE_REFERANCES_SUCCESS = "DELETE_REFERANCES_SUCCESS"

export const DELETE_POPUP = "DELETE_POPUP"
export const DELETE_POPUP_SUCCESS = "DELETE_POPUP_SUCCESS"

export const DELETE_SLIDER_SUCCESS = "DELETE_SLIDER_SUCCESS"
export const DELETE_SLIDER = "DELETE_SLIDER"
export const DELETE_NEWS = "DELETE_NEWS"
export const DELETE_NEWS_SUCCESS = "DELETE_NEWS_SUCCESS"
export const DELETE_MEGA_SUCCESS = "DELETE_MEGA_SUCCESS"
export const DELETE_MEGA = "DELETE_MEGA"
export const ADD_MEGA_SUCCESS = "ADD_MEGA_SUCCESS"

export const GET_DYNAMICFORM_EXTRA_EXTRA = "GET_DYNAMICFORM_EXTRA_EXTRA"
export const GET_DYNAMICFORMEXTRAEXTRA_SUCCESS = "GET_DYNAMICFORMEXTRAEXTRA_SUCCESS"
export const GET_DYNAMICFORMEXTRA_SUCCESS = "GET_DYNAMICFORMEXTRA_SUCCESS"
export const GET_DYNAMICFORM_EXTRA = "GET_DYNAMICFORM_EXTRA"
export const GET_CLASSES_SUCCESS = "GET_CLASSES_SUCCESS"
export const GET_CLASSES = "GET_CLASSES"
export const GET_USERS = "GET_USERS"
export const GET_USERS_SUCCESS = "GET_USERS_SUCCESS"
export const GET_USERS_FAIL = "GET_USERS_FAIL"


export const GET_GALLERY_SUCCESS = "GET_GALLERY_SUCCESS"
export const GET_GALLERY = "GET_GALLERY"

export const UPDATE_WORKSHOP2_SUCCESS = "UPDATE_WORKSHOP2_SUCCESS"

export const UPDATE_SUBDOMAIN = "UPDATE_SUBDOMAIN"

export const UPDATE_NEWS = "UPDATE_NEWS"

export const UPDATE_PROJECT = "UPDATE_PROJECT"

export const UPDATE_DYNAMICFORM = "UPDATE_DYNAMICFORM"
export const GET_DYNAMICFORM_SUCCESS = "GET_DYNAMICFORM_SUCCESS"
export const UPDATE_DYNAMICFORM_SUCCESS = "UPDATE_DYNAMICFORM_SUCCESS"


export const ADD_DYNAMICFORM_SUCCESS = "ADD_DYNAMICFORM_SUCCESS"

export const UPDATE_SLIDER = "UPDATE_SLIDER"
export const UPDATE_SUCCESS_PROJECT = "UPDATE_SUCCESS_PROJECT"
export const UPDATE_SUCCESS_GALLERY = "UPDATE_SUCCESS_GALLERY"

export const UPDATE_COURSESCHEDULES = "UPDATE_COURSESCHEDULES"
export const UPDATE_SUBDOMAIN_SUCCESS = "UPDATE_SUBDOMAIN_SUCCESS"
export const UPDATE_WORKSHOPSESSION_SUCCESS = "UPDATE_WORKSHOPSESSION_SUCCESS"
export const UPDATE_SUCCESS_COURSESCHEDULES = "UPDATE_SUCCESS_COURSESCHEDULES"
export const UPDATE_SUCCESS_TEACHER = "UPDATE_SUCCESS_TEACHER"
export const UPDATE_SUCCESS_SLIDER = "UPDATE_SUCCESS_SLIDER"
export const UPDATE_SUCCESS_NEWS = "UPDATE_SUCCESS_NEWS"
export const UPDATE_SUCCESS_MEGA = "UPDATE_SUCCESS_MEGA"
export const UPDATE_MEGA = "UPDATE_MEGA"
export const UPDATE_WORKSHOP2 = "UPDATE_WORKSHOP2"
export const UPDATE_GALLERY = "UPDATE_GALLERY"
export const UPDATE_REFERANCES = "UPDATE_REFERANCES"
export const UPDATE_REFERANCES_SUCCESS = "UPDATE_REFERANCES_SUCCESS"

export const GET_TEACHER_WORKSHOP = "GET_TEACHER_WORKSHOP"
export const GET_WORKSHOP2_SUCCESS = "GET_WORKSHOP2_SUCCESS"
export const GET_SUBPROJECT_SUCCESS = "GET_SUBPROJECT_SUCCESS"

export const GET_AUTHORITY = "GET_AUTHORITY"
export const GET_CONTACT = "GET_CONTACT"
export const UPDATE_CONTACT = "UPDATE_CONTACT"
export const GET_AUTH_SUCCESS = "GET_AUTH_SUCCESS"
export const UPDATE_AUTH = "UPDATE_AUTH"
export const GET_WORKSHOP2 = "GET_WORKSHOP2"
export const GET_REFERANCES = "GET_REFERANCES"
export const GET_REFERANCES_SUCCESS = "GET_REFERANCES_SUCCESS"
export const ADD_REFERANCES = "ADD_REFERANCES"
export const ADD_REFERANCES_SUCCESS = "ADD_REFERANCES_SUCCESS"
export const ADD_DYNAMIC_FORM = "ADD_DYNAMIC_FORM"


export const GET_AUTHUPDATE_SUCCESS = "GET_AUTHUPDATE_SUCCESS"
export const GET_SUBPROJECT = "GET_SUBPROJECT"
export const GET_CLASSATTENDANCE = "GET_CLASSATTENDANCE"
export const GET_CLASSATTENDANCE_SUCCESS = "GET_CLASSATTENDANCE_SUCCESS"

export const UPDATE_LESSONS_TIME = "UPDATE_LESSONS_TIME"
export const ADD_LESSONSTIME_SUCCESS = "ADD_LESSONSTIME_SUCCESS"
export const ADD_LESSONS_TIME = "ADD_LESSONS_TIME"
export const ADD_WORKSHOP2 = "ADD_WORKSHOP2"
export const ADD_WORKSHOP2_SUCCESS = "ADD_WORKSHOP2_SUCCESS"


export const ADD_APPSETTING = "ADD_APPSETTING"
export const ADD_WORKSHOPSUBDOMAIN = "ADD_WORKSHOPSUBDOMAIN"
export const ADD_COURSE = "ADD_COURSE"
export const ADD_MEGA = "ADD_MEGA"
export const ADD_NEWS = "ADD_NEWS"
export const ADD_NEWS_SUCCESS = "ADD_NEWS_SUCCESS"
export const ADD_PROJECT = "ADD_PROJECT"
export const ADD_SLIDER = "ADD_SLIDER"
export const ADD_SLIDER_SUCCESS = "ADD_SLIDER_SUCCESS"

// ─── CATALOG (Kataloglar) ───
export const GET_CATALOG = "GET_CATALOG"
export const GET_CATALOG_SUCCESS = "GET_CATALOG_SUCCESS"
export const ADD_CATALOG = "ADD_CATALOG"
export const ADD_CATALOG_SUCCESS = "ADD_CATALOG_SUCCESS"
export const UPDATE_CATALOG = "UPDATE_CATALOG"
export const UPDATE_SUCCESS_CATALOG = "UPDATE_SUCCESS_CATALOG"
export const DELETE_CATALOG = "DELETE_CATALOG"
export const DELETE_CATALOG_SUCCESS = "DELETE_CATALOG_SUCCESS"

export const ADD_POPUP = "ADD_POPUP"
export const UPDATE_TEACHER = "UPDATE_TEACHER"
export const UPDATE_WORKSHOPSESSION = "UPDATE_WORKSHOPSESSION"
export const UPDATE_POPUP = "UPDATE_POPUP"
export const GET_POPUP_SUCCESS = "GET_POPUP_SUCCESS"
export const UPDATE_POPUP_SUCCESS = "UPDATE_POPUP_SUCCESS"
export const GET_TEACHERWORKSHOP_SUCCESS = "GET_TEACHERWORKSHOP_SUCCESS"
export const UPDATE_LESSONSTIME_SUCCESS = "UPDATE_LESSONSTIME_SUCCESS"

export const GET_WORKSHOP_SUCCESS = "GET_WORKSHOP_SUCCESS"
export const GET_WORKSHOPSESSION_SUCCESS = "GET_WORKSHOPSESSION_SUCCESS"
export const GET_APPLICATION_SUCCESS = "GET_APPLICATION_SUCCESS"
export const GET_SLIDER_SUCCESS = "GET_SLIDER_SUCCESS"
export const GET_PROJECTS_SUCCESS = "GET_PROJECTS_SUCCESS"
export const GET_NEWS_SUCCESS = "GET_NEWS_SUCCESS"
export const GET_MEGA_SUCCESS = "GET_MEGA_SUCCESS"
export const GET_TEACHER_SUCCESS = "GET_TEACHER_SUCCESS"
export const GET_DYNAMIC_SUCCESS = "GET_DYNAMIC_SUCCESS"

/* POPUP */
export const GET_POPUP = "GET_POPUP"
export const GET_WORKSHOP = "GET_WORKSHOP"
export const GET_CourseSchedulesMega = "GET_CourseSchedulesMega"
export const GET_WorkshopSessionMega = "GET_WorkshopSessionMega"
export const GET_TeacherMega = "GET_TeacherMega"
export const GET_EVENT = "GET_EVENT"
export const GET_DYNAMICFORM = "GET_DYNAMICFORM"
export const GET_SLIDER = "GET_SLIDER"
export const GET_PROJECTSNEW = "GET_PROJECTSNEW"
export const GET_NEWS = "GET_NEWS"
export const GET_MEGA = "GET_MEGA"

/* USERS PROFILE */
export const GET_USER_PROFILE = "GET_USER_PROFILE"
export const GET_USER_PROFILE_SUCCESS = "GET_USER_PROFILE_SUCCESS"
export const GET_USER_PROFILE_FAIL = "GET_USER_PROFILE_FAIL"


/**
 * add user
 */
export const ADD_NEW_USER = "ADD_NEW_USER"
export const ADD_USER_SUCCESS = "ADD_USER_SUCCESS"
export const ADD_USER_FAIL = "ADD_USER_FAIL"

/**
 * Edit user
 */
export const UPDATE_USER = "UPDATE_USER"
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS"
export const UPDATE_USER_FAIL = "UPDATE_USER_FAIL"

/**
 * Delete user
 */
export const DELETE_USER = "DELETE_USER"
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS"
export const DELETE_USER_FAIL = "DELETE_USER_FAIL"
